import React from 'react';
import { Container } from './styles';
import {
  Link as ReactLink,
  LinkProps as ReactLinkProps,
} from 'react-router-dom';

type LinkProps = {
  title: string;
  to: ReactLinkProps['to'];
  'data-cy'?: string;
};

export default function Link(props: LinkProps) {
  const { title, to, 'data-cy': dataCy } = props;

  return (
    <Container>
      <ReactLink to={to}>
        <p data-cy={dataCy && `link-title-${dataCy}`}>{title}</p>
      </ReactLink>
    </Container>
  );
};
